module.exports = __webpack_public_path__ + "img/07.83ade366.png";